import { useQuery } from '@tanstack/react-query';

import { queryFn } from './queryFn';

export const getQueryKey = () => ['FOLLOWED_NARRATIVES'] as const;

export const useFollowedNarratives = () => {
  return useQuery({
    queryFn,
    queryKey: getQueryKey(),
    retry: 1,
    staleTime: 3600000,
  });
};
